import {
  CATHEDRA_FETCH_COMPLETED,
  CATHEDRA_FETCH_STARTED,
  CATHEDRA_LIST_FETCH_COMPLETED,
  CATHEDRA_LIST_FETCH_COMPLETED_2,
  FACULTY_LIST_FETCH_COMPLETED,
  NETWORK_REQUEST_SENT,
} from "./types";
import { buildDefaultHeaders } from "./helper";
import { BACKEND_URL_PREFIX } from "../utils/const";
import { teachers } from "./faculty";
import { checkAndUpdateToken } from "./auth";
import fileDownload from "js-file-download";

export const list = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/faculty?limit=1000&offset=0&web=1`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: FACULTY_LIST_FETCH_COMPLETED, list: result.items });
      dispatch(cathList());
      dispatch(teachers());
    }
  }
};

export const cathList = (page = 0, limit = 1000) => async (dispatch, getState) => {
  console.log(3)
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const offset = page * limit;
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/cathedra?limit=${limit}&offset=${offset}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ 
        type: CATHEDRA_LIST_FETCH_COMPLETED, 
        list: result.items || [],
        total: result.total || result.items.length,
        pageCount: Math.ceil((result.total || result.items.length) / limit) });
    }
  }
};

export const cathList2 = () => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/ktp/cathedra`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const result = await response.json();
      dispatch({ type: CATHEDRA_LIST_FETCH_COMPLETED_2, list: result });
    }
  }
};

export const cathedra = (id) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {
    dispatch({type: CATHEDRA_FETCH_STARTED})
    const response = await fetch(
      `${BACKEND_URL_PREFIX}/cathedra/${id}`,
      buildDefaultHeaders(getState)
    );

    dispatch({ type: NETWORK_REQUEST_SENT, response });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: CATHEDRA_FETCH_COMPLETED, cathedra: data.cathedra[0] });
    }
  }
};

export const getCathedraFile = (
  cathId, filename
) => async (dispatch, getState) => {
  await dispatch(checkAndUpdateToken());
  if (getState().auth.token) {

    const response = await fetch(
      `${BACKEND_URL_PREFIX}/cathedra/${cathId}/${filename}`,
      {
        ...buildDefaultHeaders(getState),
      }
    );

    if (response.ok) {
      const data = await response.blob();
      fileDownload(data, filename);
      // dispatch({ type: GET_STUDENT_HOMEWORK_FILE_COMPLETED });
    } else {
      // dispatch({ type: GET_STUDENT_HOMEWORK_FILE_FAILED });
    }
  }
};
